import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import { breakpoints, colors, fontFamily } from '../../ui/variables';

export const NotFoundStyle = styled.main`
  width: 100%;

  .not-found-container {
    padding: ${headerVariables.main.height.iphone + 36}px 20px 36px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      align-items: center;
      display: flex;
      min-height: 100vh;
      padding: ${headerVariables.main.height.iphone + 36}px 64px 36px;
    }

    .not-found-text-content {
      margin-bottom: 32px;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        max-width: 40%;
        min-width: 40%;
        padding-right: 32px;
      }

      .not-found-title {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.veryDarkGray};
        font-size: 52px;
        letter-spacing: 0.25px;
        line-height: 71px;
        margin-bottom: 24px;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 564px;
        }
      }

      .not-found-instruction {
        margin-bottom: 32px;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 564px;
        }

        p {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.veryDarkGray};
          font-size: 18px;
          letter-spacing: 0.25px;
          line-height: 31px;
          margin-bottom: 24px;

          &:last-child {
            margin-bottom: 0;
          }

          a {
            color: ${colors.softBlue};
            text-decoration: underline;
          }
        }
      }

      .go-to-button-wrapper {
        max-width: 284px;
      }
    }

    .not-found-image-content {
      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        max-width: 60%;
        min-width: 60%;
      }

      .not-found-illustration {
        display: block;
        height: auto;
        width: 100%;
      }
    }
  }
`;
